export const LOGIN_URI = 'v1/users/login/';
export const REGISTER_URI = 'v1/users/user-registration/';
export const REGISTER_URL_COUPON = 'v1/users/user-registration-with-coupon/';
export const WEBSITE_URL = 'v1/websites/';
export const WEBSITE_URL_V2 = 'v2/websites/';
export const CHANGE_PASSWORD_URL = 'v1/users/change-password/';
export const RESET_PASSWORD_URL = 'v1/users/reset-password/';
export const SUBSCRIBERS_URL = 'v1/subscribers/';
export const PROFILE_URL = 'v1/users/profile/';
export const TOPICS_URL = '/topics/';
export const TOPICS_THEME_URL = 'v1/topics/themes/';
export const SEGMENT_URL = 'v1/segments/';
export const DRIP_STATS_URL = 'v1/webpush/drip/stats/';
export const USER_AGENTS_URL = 'v1/users/agent';
export const SHOPIFY_LOGIN_URL = 'v1/users/shopify-login/';
export const CUMULATIVE_DASHBOARD = 'v1/users/overall-count/';

export const DRIP_POSTFIX_URL ='/drip-notification/';
export const WELCOME_POSTFIX_URL ='/welcome-notification/';
export const THEMES_POSTFIX_URL = '/topics/themes/';
export const SUBSCRIBERS_GROWTH_POSTFIX_URL = '/subscribers/growth/';


export const DESKTOP_PROMPT ='https://test-api.chirpyweb.com/v1/websites/desktop-prompt/';
export const MOBILE_PROMPT ='https://test-api.chirpyweb.com/v1/websites/mobile-prompt/';
export const GDPR_PROMPT ='https://test-api.chirpyweb.com/v1/websites/gdpr-prompt/';


